import React from 'react';
import { cn } from '@/lib/utils';

export type ButtonSize = 'tiny' | 'small' | 'medium' | 'large';

const buttonWidth: Record<ButtonSize, string> = {
  tiny: '24px',
  small: '24px',
  medium: '36px',
  large: '40px',
};

const buttonHeight: Record<ButtonSize, string> = {
  tiny: '20px',
  small: '24px',
  medium: '24px',
  large: '40px',
};

const buttonFontSize: Record<ButtonSize, string> = {
  tiny: '11px',
  small: '11px',
  medium: '12px',
  large: '12px',
};

type StudioButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  size: ButtonSize;
  fontSize?: string;
  color?: string;
};

export const StudioButton = ({ children, className, size, fontSize, color, ...props }: StudioButtonProps) => (
  <button
    type="button"
    className={cn(className, [
      'flex justify-center items-center p-1.5 rounded border border-solid border-venn-grey-30 bg-venn-white',
      'whitespace-nowrap flex-shrink-0 text-venn-dark-blue',
      `min-w-[${buttonWidth[size]}] h-[${buttonHeight[size]}]`,
      color && `text-[${color}]`,
      fontSize ? `text-[${fontSize}]` : `text-[${buttonFontSize[size]}]`,
    ])}
    {...props}
  >
    {children}
  </button>
);
